import { ProductMetafields } from "~/types";

type RedirectUrl = {
    ButtonCaption?: string,
    RedirectUrl?: string
}
export default function RedirectUrlButton({ product }: { product: ProductMetafields }) {
    const redirectUrl: RedirectUrl = JSON.parse(product.redirectUrl?.value ?? "{}") ?? {};
    return (
        <>
            {redirectUrl && redirectUrl?.RedirectUrl &&
                <a id="btnRedirect" className="black-button" href={redirectUrl?.RedirectUrl}>{redirectUrl?.ButtonCaption}</a>
            }
        </>

    )
}